export default __webpack_public_path__ + "static/media/banner-2.1aa7cc52.jpg";